import UserPreviewItem from './UserPreviewItem';

export default UserPreviewItem;
